import { render, staticRenderFns } from "./OpenTicket.vue?vue&type=template&id=372dbc73&scoped=true"
import script from "./OpenTicket.vue?vue&type=script&lang=js"
export * from "./OpenTicket.vue?vue&type=script&lang=js"
import style0 from "./OpenTicket.vue?vue&type=style&index=0&id=372dbc73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372dbc73",
  null
  
)

export default component.exports